module.exports = __webpack_public_path__ + "static/banner-42eeaeaa9462e1f4e15b7dca454fc691.svg";